import { render } from "./SystemWalletWarningDialog.vue?vue&type=template&id=65586c7e&scoped=true"
import script from "./SystemWalletWarningDialog.vue?vue&type=script&lang=js"
export * from "./SystemWalletWarningDialog.vue?vue&type=script&lang=js"

import "./SystemWalletWarningDialog.vue?vue&type=style&index=0&id=65586c7e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65586c7e"]])

export default __exports__